import React, {createContext, useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {enquireScreen} from 'enquire-js';

const ResponsiveContext = createContext();


let _isMobile;
let _isTablet;

const mobileQuery = 'only screen and (max-width: 992px)';

enquireScreen((b) => {
  _isTablet = b;
}, mobileQuery);


function ResponsiveProvider({children}) {
  const [isMobile, setMobile] = useState(_isMobile);
  const [isTablet, setTablet] = useState(_isTablet);

  useEffect(() => {
    enquireScreen((b) => {
      setMobile(!!b);
    });
  }, []);

  useEffect(() => {
    enquireScreen((b) => {
      setTablet(!!b);
    }, mobileQuery);
  }, []);

  return (
    <ResponsiveContext.Provider value={{
      isMobile: isMobile,
      isTablet: isTablet,
    }}>
      {children}
    </ResponsiveContext.Provider>
  );
}

function useResponsive() {
  const context = useContext(ResponsiveContext);
  if (context === undefined) {
    throw new Error('useResponsive must be used within a ResponsiveProvider');
  }
  const {
    isMobile,
    isTablet,
  } = context;

  return {
    isMobile,
    isTablet,
  };
}

ResponsiveProvider.propTypes = {
  isMobile: PropTypes.bool,
  children: PropTypes.any
};


export {ResponsiveProvider, useResponsive};
